import httpClient from './http-clients';

// const fetchAllProducts = async () => {
//   const response = await httpClient.get();
//   return response.data;
// };

// Fetch all products
export const fetchAllProducts = async (page) => {
  const response = await httpClient.get(`products/get-products?limit=0`);
  return response.data;
};

// Fetch one page of Sales & Offers products, filtered server-side.
// Works around two API quirks: with `salesType` the endpoint applies the page
// offset but ignores `limit` (so we trim), and it answers 404 "No products
// found" instead of an empty list.
export const fetchProductsBySalesType = async (
  salesType,
  page = 1,
  limit = 40
) => {
  try {
    const response = await httpClient.get('products/get-products', {
      params: { salesType, page, limit },
    });
    const body = response.data;
    return {
      ...body,
      data: {
        ...body?.data,
        products: (body?.data?.products || []).slice(0, limit),
      },
    };
  } catch (error) {
    if (error?.response?.status === 404) {
      return { data: { products: [], total: 0, totalPages: 0 } };
    }
    throw error;
  }
};

// Fetch all new products
export const fetchAllNewProducts = async () => {
  const response = await httpClient.get(
    'products/get-products?type=new&page=1&limit=50'
  );
  return response.data;
};

// Fetch all trending products
export const fetchSingleProduct = async (productId) => {
  const response = await httpClient.get(
    `/products/get-single-product/${productId}`
  );
  return response.data.data;
};

// Fetch products by category and subcategory
export const fetchProductsByCategoryAndSubcategory = async (
  category,
  subcategory,
  limit = 10,
  page = 1
) => {
  const response = await httpClient.get(
    `products/subcategory?category=${category}&subcategory=${subcategory}&limit=${limit}&page=${page}`
  );
  return response.data;
};

// Fetch all products by category
export const getAllCategories = async () => {
  const response = await httpClient.get('products/categories');
  return response.data;
};

// Fetch products by category
export const getCategorySubcategories = async (category) => {
  const response = await httpClient.get(
    `products/single-categories/${category}`
  );
  return response.data;
};

// Toggle products for favourites
export const toggleProductToFavourite = async (productID) => {
  const response = await httpClient.post('products/toggle-favorite', {
    productID,
  });
  return response.data;
};

// Fetch favourite products
export const fetchFavouriteProducts = async () => {
  const response = await httpClient.get('products/get-favourite-products');
  return response.data.data;
};

// Fetch products by search query
export const addReviewforProduct = async (data) => {
  const response = await httpClient.post('products/add-product-review', data);
  return response.data;
};

// Fetch reviews for a specific product
export const fetchReviewsForProduct = async (productId) => {
  const response = await httpClient.get(
    `products/get-product-reviews/${productId}`
  );
  return response.data;
};

// Fetch products by search query
// `signal` lets React Query cancel a request once it's outdated (e.g. the
// user kept typing), so slow responses can't overwrite newer ones.
export const fetchProductsBySearch = async (
  query,
  page = 1,
  { limit = 40, signal } = {}
) => {
  if (!query) return []; // don't fetch if the query is empty
  const response = await httpClient.get('products/search', {
    params: { q: query, page, limit },
    signal,
  });
  return response.data;
};

// Fetch products by vendor
export const fetchProductsByVendor = async (vendorId, limit, page) => {
  if (!vendorId) return []; // don't fetch if the vendorId is empty
  const response = await httpClient.get(
    `products/get-products-by-vendor/${vendorId}?limit=${limit}&page=${page}`
  );
  return response.data;
};
